import { loadStripe } from "@stripe/stripe-js";

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.warn(
    "Stripe disabled: set REACT_APP_STRIPE_PUBLISHABLE_KEY in .env"
  );
}

export const stripePromise = stripePublishableKey
  ? loadStripe(stripePublishableKey)
  : null;
